
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 3.425c0-1.268 0-1.902.257-2.359a2 2 0 011.011-.88C1.756-.006 2.384.08 3.64.256l2.6.36c.978.137 1.468.205 1.836.44a2 2 0 01.742.852C9 2.305 9 2.798 9 3.786V7h3.586l-.293-.293a1 1 0 011.414-1.414l2 2a1 1 0 010 1.414l-2 2a1 1 0 01-1.414-1.414L12.586 9H9V7H5a1 1 0 000 2h4v3.214c0 .987 0 1.481-.182 1.878a2 2 0 01-.742.853c-.368.235-.858.302-1.836.438l-2.6.361c-1.256.175-1.884.262-2.372.07a2 2 0 01-1.01-.88C0 14.477 0 13.844 0 12.574V3.426z","fill":"#FF2640"}})])
          )
        }
      }
    